import{componentFactory,datasetFactory}from'../../../fc-core/src/lib';export default function(a){let b,c,d,e,f=a.getFromEnv('dataSource'),g=f.dataset,h=a.getChildren(),i=h.canvas[0],j=b=i.getChildren('vCanvas')[0],k=a.config.defaultDatasetType||'';return g?void(d=a.getDSGroupdef(),d&&(componentFactory(b,d,'datasetGroup_'+k,1,[g]),e=b.getChildren('datasetGroup_'+k)),e&&(j=e[0]),c=a.getDSdef(),datasetFactory(j,c,'dataset',g.length,g)):void a.setChartMessage()}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/factories/multiseries-dataset.js
// module id = null
// module chunks = 